import * as React from 'react';
import Button from '@material-ui/core/Button';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

function PremiumPastDue({profile} :any) {
  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
       <p><strong>Your subscription is past due</strong></p>
       <Button
        href={ profile.subscription?.billing_portal_url }
        size="small"
        variant="outlined"
        startIcon={<AccountBalanceIcon />}
      >
        Update your subscription
      </Button>
      </p>
    </div>
  );
}

export default PremiumPastDue;
